<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="Dedication-ded"><span class="ePub-I">To Mark,</span></p>
<p class="Dedication-ded"><span class="ePub-I">who puts up with my nail polish obsession</span></p>
<p class="Dedication-ded"><span class="ePub-I">with love and a big smile.</span></p>
<p class="Dedication-ded"><span class="ePub-I">Love you!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1c354d4e